import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart,
  TimeScale,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  ChartOptions,
} from "chart.js";
import "chartjs-adapter-moment";
import zoomPlugin from "chartjs-plugin-zoom";
import { Grid } from "@mui/material";
import { getGraphTypeColors } from "./commons";

const LineSurveyChart = ({
  yData,
  xData,
}: {
  yData: string[];
  xData: number[];
}) => {
  const parseData = () => {
    const processedData: any = [];

    Object.keys(yData).forEach((label, index) => {
      const newItem = { key: yData[index], value: xData[index] };
      processedData.push(newItem);
    });

    return {
      datasets: [
        {
          label: "Data",
          data: processedData,
          fill: true,
          ...getGraphTypeColors(1, false),
          pointRadius: 6,
          parsing: {
            xAxisKey: "key",
            yAxisKey: "value",
          },
        },
      ],
    };
  };

  Chart.register(
    TimeScale,
    PointElement,
    LineController,
    LineElement,
    LinearScale,
    zoomPlugin
  );

  return (
    <div className="h-[100%,] flex flex-col justify-around">
      <Line
        data={parseData()}
        options={{
          scales: {
            x: {
              type: "time",
              time: {
                unit: "day",
                displayFormats: {
                  millisecond: "MM/DD/YY",
                  second: "MM/DD/YY",
                  minute: "MM/DD/YY",
                  hour: "MM/DD/YY",
                  day: "MM/DD/YY",
                  week: "MM/DD/YY",
                  month: "MM/DD/YY",
                  quarter: "MM/DD/YY",
                  year: "MM/DD/YY",
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false, // Display legend for multiple lines
            },
            zoom: {
              pan: {
                enabled: false,
                mode: "xy",
              },
              zoom: {
                pinch: {
                  enabled: false, // Enable pinch zooming
                },
                wheel: {
                  enabled: false, // Enable wheel zooming
                },
                mode: "x",
              },
            },
          },
          interaction: {
            mode: "nearest",
            axis: "x",
            intersect: true,
          },
          backgroundColor: "#F2F8FD",
          maintainAspectRatio: false,
        }}
      />
    </div>
  );
};

export default LineSurveyChart;
